// @flow
import type {ActionType} from 'constants/flow/flowTypes';
import {CONTACTS} from 'constants/actions';

export const initialState = '';

/**
 * Set notification message to store
 * @param {string} state - Current state
 * @param {ActionType<string>} action - Received action
 * @returns {string} state - Returned state
 */
export const notification = (state: string = initialState, action: ActionType<string>): string => {
    switch (action.type) {
        case CONTACTS.SET_NOTIFICATION:
            return action.payload;
        default:
            return state;
    }
};
